<template>
  <HeadlessRadioGroup
    :modelValue="modelValue"
    @update:modelValue="(v) => $emit('update:modelValue', v)"
  >
    <HeadlessRadioGroupLabel v-if="label">
      {{ label }}
    </HeadlessRadioGroupLabel>
    <div
      :class="{
        'flex flex-wrap items-center justify-between gap-4': horizontal,
      }"
    >
      <HeadlessRadioGroupOption
        v-for="option in options"
        v-slot="{ checked }"
        :value="option.value"
      >
        <div
          class="flex items-center gap-2 py-1 pl-1 pr-2 rounded-md select-none cursor-pointer transition"
          :class="checked ? 'text-nami-comi-blue' : ''"
        >
          <IconCircleFilled
            :size="16"
            v-if="checked"
            class="transition"
            :class="!checked ? 'text-nami-comi-blue/0' : 'text-nami-comi-blue'"
          />
          <IconCircle :size="16" v-else />
          <span class="truncate">
            {{ option.name }}
          </span>
        </div>
      </HeadlessRadioGroupOption>
    </div>
  </HeadlessRadioGroup>
</template>

<script setup lang="ts">
import { IconCircle, IconCircleFilled } from "@tabler/icons-vue";

defineProps<{
  modelValue: string;
  options: { name: string; value: string }[];
  label?: string;
  horizontal?: boolean;
}>();

defineEmits<{
  (e: "update:modelValue", v: string): void;
}>();
</script>
